import api from './api';

export const getContactBulkActions = (page, params) => {
  return api.get('admin/ContactBulkActions', { params: { page: page, limit: 5, ...params } });
};

export const getContactBulkAction = id => {
  return api.get(`admin/ContactBulkActions`, { params: { searchItem: 'id', search: id } });
};

export const updateContactBulkAction = (contactBulkActionId, update) => {
  return api.put(`admin/ContactBulkActions/item/${contactBulkActionId}`, { object: update });
};
